<template>
  <div>
    <el-tabs type="border-card"
             @tab-click="tabclick">
      <el-tab-pane label="账户信息">

      </el-tab-pane>
      <el-tab-pane label="本地区（县）单位排名">

      </el-tab-pane>
      <el-tab-pane label="本地区（县）人员排名">

      </el-tab-pane>
      <el-tab-pane label="本单位人员排名">

      </el-tab-pane>
      <el-tab-pane label="排行榜"
                   name="phb">
      </el-tab-pane>
      <el-tab-pane label="单位标签管理"
                   name="tags">
      </el-tab-pane>
            <el-tab-pane label="审核人员" name='change'> </el-tab-pane>
    </el-tabs>
    <div class="content-wrap">
      <user-info :dwform="dwform" v-show="zhxxisshow"></user-info>
      <tags v-if="currentTab=='tab-tags'" />
      <examinePeople v-if="currentTab=='tab-change'"/>
      <div class="modifyform" v-show="modifyshow">
        <el-form
          :model="form"
          status-icon
          :rules="rules"
          ref="form"
          label-width="100px"
          size="mini"
          labelWidth="auto"
          style="width: 100%"
        >
          <!-- left -->
          <el-row :gutter="20">
            <el-col :sm="24" :md="18" :lg="18" :xl="12" :offset="0">
              <el-form-item label="名称：" prop="name">
                <!-- 文本框 -->
                <el-input
                  v-model.trim="form.name"
                  style="width: 194px"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机：" prop="mobile">
                <!-- 文本框 -->
                <el-input
                  v-model.trim="form.mobile"
                  style="width: 194px"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证：" prop="idcard">
                <!-- 文本框 -->
                <el-input
                  v-model.trim="form.idcard"
                  style="width: 194px"
                ></el-input>
              </el-form-item>
              <el-form-item label="标签：" prop="tag">
                <el-select
                  v-model="form.tag"
                  value-key
                  placeholder
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in tags"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="五进类型：" prop="wjlb">
                <el-select
                  v-model="form.wjlb"
                  value-key
                  placeholder
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in wjtype"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="题库类型：" prop="question_type">
                <el-select
                  v-model="form.question_type"
                  value-key
                  placeholder
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in questionlist"
                    :key="item.row_id"
                    :label="item.name"
                    :value="item.row_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label>
                <div style="display:flex">
                <el-button
                  type="primary"
                  @click="submit"
                  size="mini"
                  >保存</el-button
                >
                <el-button
                  @click="back"
                  size="mini"
                  >取消</el-button
                >
                </div>
                
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-show="tableisshow">
        <div class="header" style="align-items: center">
          <export-data
            :selectdata="tableData"
            :Field="this.dataField"
            :dwform="this.dwform"
            :isout="this.isout"
          ></export-data>
          <search-input
            class="search"
            ref="search"
            :getname="getname"
          ></search-input>
          <el-select
            v-if="currentTab == 'tab-1'"
            v-model="tag"
            placeholder="请选择"
            size="mini"
            clearable
            style="height: 100%"
            @change="queryBzTable"
          >
            <el-option
              v-for="item in tags"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <el-table
          :row-style="{ height: '36px' }"
          :cell-style="{ padding: '0px' }"
          :header-row-style="{ height: '20px' }"
          :header-cell-style="{
            background: '#eef1f6',
            padding: '6px 0',
          }"
          style="width: 100%; color: #606266"
          ref="multipleTable5"
          :data="tableData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          tooltip-effect="dark"
          :height="clientHeight"
        >
          <!--           <el-table-column type="selection"
                           width="55"> </el-table-column> -->
          <el-table-column
            v-for="(item, index) in currentcloumn.title"
            :key="index"
            show-overflow-tooltip
            :prop="currentcloumn.enname[index]"
            :label="item"
            min-width="150"
            :sort-method="
              (a, b) => {
                return a[item.props] - b[item.props];
              }
            "
          >
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100" v-if="this.currentTab=='tab-3'">
            <template slot-scope="scope">
              <div style="display: flex">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                &nbsp;&nbsp;
                <el-popconfirm title="确定删除吗？" @confirm="del(scope.row)">
                  <el-button type="text" size="small" 
                  slot="reference"
                  >删除</el-button
                >
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagi-nation
          :Count="Count"
          @size-change="handleSizeChange"
          @current-change="onCurrentChange"
          ref="pagination"
          v-show="pagiisshow"
        ></pagi-nation>
      </div>
    </div>
  </div>

</template>

<script>
import phbTable from '@/components/phbTable'
import pagiNation from '@/components/pagiNation'
import examinePeople from"@/components/examinePeople.vue"
import exportData from '@/components/exportData';
import userInfo from '@/components/userInfo.vue'
import searchInput from '@/components/searchInput';
import { getlist, getdwb3, getdistlist } from "@/utils/request";
import tags from './tags.vue';
export default {
  components: { phbTable, pagiNation, exportData, userInfo, searchInput, tags,examinePeople },
  data () {
    return {
      loading: false,
      dwform: {},
      Count: 0,
      currentPage: 1,
      PageSize: 15,
      currentTab: "",
      currenttable: {}, name: "",
      tag: "",
      tags: [],
      sss: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["department", "score", "bdqpm"]
      },
      bdqdw: {
        title: ["姓名", "单位", "竞赛分", "年度分", "本地区排名"],
        enname: ["name", "department", "score", "score_2023", "bdqpm"]
      },
      sss1: {
        title: ["单位名称", "总分", "本地区排名"],
        enname: ["department", "score", "bdqpm"]
      },
      bdqdw1: {
        title: [
          "姓名",
          "手机",
          "身份证",
          "单位",
          "单位标签",
          "五进类型",
          "题库类型",
          "竞赛分",
          "日常学分",
          "本年学时",
          "2021积分",
          "2022积分",
          "2023积分",
          "2021学时",
          "2022学时",
          "2023学时",
        ],
        enname: [
          "name",
          "mobile",
          "idcard",
          "department",
          "tag",
          "wjlb",
          "question_type",
          "score",
          "score_year",
          "year_hour",
          "score_2021",
          "score_2022",
          "score_2023",
          "classhour_2021",
          "classhour_2022",
          "classhour_2023",
        ],
      },
      bdqdw21: {
        title: [
          "姓名",
          "单位",
          "标签",
          "五进人员类型",
          "竞赛分",
          "年度分",
          "本单位排名",
        ],
        enname: [
          "name",
          "department",
          "tag",
          "wjlb",
          "score",
          "score_2023",
          "bdqpm",
        ],
      },
      sss2: {
        title: ["单位名称", "总分"],
        enname: ["department", "score"]
      },
      bdqdw2: {
        title: ["姓名", "单位", "竞赛分", "年度分"],
        enname: ["name", "department", "score", "score_2023"]
      },
      tableData: [],
      modifyshow: false,
      form: {},
      wjtype: ["企业", "农村", "社区", "学校", "家庭"],
      questionlist: [
        {
          row_id:"1",
          name:"工程建设"
        },
        {
          row_id:"2",
          name:"工程运行"
        },
        {
          row_id:"3",
          name:"建设+运行"
        },
      ],
    }
  },
  methods: {
        back(){
      this.modifyshow=false
      this.currentTab="tab-3"
      this.queryBzTable()
    },
    submit() {
      let params = {
        row_id: this.form.row_id,
        name: this.form.name,
        tag: this.form.tag,
        wjlb: this.form.wjlb,
        question_type: this.form.question_type,
      };
      if (!this.form.mobile.includes("*")) {
        params.mobile= this.form.mobile
      }
      if (!this.form.idcard.includes("*")) {
        params.idcard= this.form.idcard
      }
      this.$http.get(this.$Api.modifyMember, { params }).then((res) => {
        if (res.data.errcode == "0") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.modifyshow=false
          this.currentTab="tab-3"
          this.queryBzTable();
        } else {
          this.$message.error({
            message: "修改失败，"+res.data.errMsg,
          });
        }
      });
    },
    del(scope) {
      let params = {
        row_id: scope.row_id,
      };
      this.$http.get(this.$Api.recycleMember, { params }).then((res) => {
        if (res.data.errcode == "0") {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.queryBzTable();
        } else {
          this.$message.error({
            message: "删除失败",
          });
        }
      });
    },
    handleClick(scope) {
      this.form = scope;
      this.form.question_type=this.questionlist.filter(v=>v.name==this.form.question_type).length?this.questionlist.filter(v=>v.name==this.form.question_type)[0].row_id:''
      this.modifyshow = true;
      this.currentTab = "modify";
    },
    queryBzTable () {
      console.log('请求了数据');
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /*       this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getMemberList', {
              params: { "pageNo": this.currentPage, "pageNum": this.PageSize, "department": this.dwform.department },
      
            }).then(res => {
              console.log(res.data);
              this.tableData = res.data.datalist;
              this.Count = res.data.total;
              this.loading = false;
            }); */
      return getlist(this.currentPage, this.PageSize, this.dwform.department, this.name, this.tag).then(
        (res) => {
          this.loading = false;
          console.log(res.data);
          this.tableData = res.data.datalist;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.year_hour=Number(v.racehour_2024)+Number(v.classhour_2024)
            v.bdqpm = index + 1 + this.PageSize * (this.currentPage - 1);
            v.question_type = v.question_type == "0" ? "" : v.question_type;
            v.question_type = v.question_type == "1" ? "工程建设" : v.question_type;
            v.question_type = v.question_type == "2" ? "工程运行" : v.question_type;
            v.question_type = v.question_type == "3" ? "建设+运行" : v.question_type;
            })
          }
          this.Count = res.data.total;

        },
      )

    },
    querydepartment () {
      console.log('请求了数据');
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getrank&showtype=2&department', {
        params: { "region": this.dwform.region, city: this.dwform.city, dist: this.dwform.dist }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.bdqpm = index + 1
        });
        this.Count = res.data.total;
        this.loading = false;
      }); */
      return getdwb3(this.dwform.region, this.dwform.city, this.dwform.dist, this.name).then(
        (res) => {
          this.loading = false;
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.bdqpm = index + 1
            });
          }
          this.Count = res.data.total;

        },
      )

    },
    querydistTable () {
      console.log('请求了数据');
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getMemberList', {
        params: { "pageNo": this.currentPage, "pageNum": this.PageSize, "region": this.dwform.region, city: this.dwform.city, dist: this.dwform.dist }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.datalist;
        this.Count = res.data.total;
        this.loading = false;
      }); */
      return getdistlist(this.currentPage, this.PageSize, this.dwform.region, this.dwform.city, this.dwform.dist, this.name).then(
        (res) => {
          this.loading = false;
          console.log(res.data);
          this.tableData = res.data.datalist;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.bdqpm = index + 1 + this.PageSize * (this.currentPage - 1)
            })
          }
          this.Count = res.data.total;

        },
      )

    },
    handleSizeChange (e) {
      console.log("分页器数值改变", e);
      this.PageSize = e;
      if (this.currentTab == "tab-2") {
        this.querydistTable()
      }
      if (this.currentTab == "tab-3") {
        this.queryBzTable()
      }
    },
    onCurrentChange (e) {
      console.log("当前页数值变化", e);
      this.currentPage = e;
      if (this.currentTab == "tab-2") {
        this.querydistTable()
      }
      if (this.currentTab == "tab-3") {
        this.queryBzTable()
      }
    },
    tabclick (tab, event) {
      this.$refs.search.clear()
      this.name = ""
      this.sss = this.sss1
      this.bdqdw = this.bdqdw1
      this.selecttableData = [];
      this.currentTab = event.target.getAttribute('id')
      this.currentPage = 1;
      this.PageSize = 15;
      console.log(this.dataField);
      this.$refs.pagination.tbclick();
      switch (this.currentTab) {
        case "tab-1":
          this.querydepartment();
          break
        case "tab-2":
          this.querydistTable();
          break
        default:
          this.queryBzTable();
          break
      }
    }, search () {
      if (this.name == "") {
        this.sss = this.sss1
        this.bdqdw = this.bdqdw1
      } else {
        this.sss = this.sss2
        this.bdqdw = this.bdqdw1
      }
      switch (this.currentTab) {
        case "tab-3":
          this.queryBzTable()
          break;
        case "tab-2":
          this.querydistTable()
          break;
        case "tab-1":
          this.querydepartment()
          break;
        default:
          break;
      }
    },
    getname (name) {
      this.name = name
    },
    getTags () {
      let dataId = JSON.parse(window.localStorage.getItem("dwform")).dataId
      let params = {
        dataId: dataId
      }
      this.$http({
        method: "get",
        url: this.$Api.getTags,
        params,
      }).then((result) => {
        console.log('result :>> ', result);
        let res = result.data.tags
        if (res !== "") {
          this.tags = res.split(",")
        }

      }).catch((err) => {

      });
    }
  },
  created () {
    let that = this;
    that.clientHeight = document.documentElement.clientHeight - 270;
    window.onresize = () => {
      that.clientHeight = document.documentElement.clientHeight - 270;
    }
    this.dwform = JSON.parse(localStorage.getItem('dwform'))
    console.log(this.dwform);
    this.getTags()
  },
  computed: {
    dataField () {
      switch (this.currentTab) {
        case "tab-1":
          return this.sss
        case "tab-2":
          return this.bdqdw
        case "tab-3":
          return this.bdqdw
        default:
          return 0
      }
    }, isout () {
      switch (this.currentTab) {
        case 'tab-2':
          return true
        case 'tab-3':
          return "dw"
        default:
          return false
      }
    },
    zhxxisshow () {
      if (this.currentTab == "" || this.currentTab == "tab-0") {
        return true
      } else {
        return false
      }
    },
    tableisshow () {
      switch (this.currentTab) {
        case "":
          return false
        case "tab-0":
          return false
        case "tab-phb":
          return false
        case "tab-tags":
          return false
        case "modify":
          return false;
        case "tab-change":
          return false
        default:
          return true
      }
    },
    currentcloumn () {
      switch (this.currentTab) {
        case "tab-1":
          return this.sss
        case "tab-2":
          return this.bdqdw
        case "tab-3":
          return this.bdqdw
        default:
          return ""
      }
    },
    phpisshow () {
      if (this.currentTab == "tab-phb") {
        return true
      } else {
        return false
      }
    },
    pagiisshow () {
      switch (this.currentTab) {
        case "tab-2":
          return true
        case "tab-3":
          return true
        default:
          return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-table {
  width: 99.9% !important;
}
.content-wrap {
  border: 1px solid #dcdfe6;
  border-top: none;
  .modifyform {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    padding: 10px;
  }
}
.el-tabs--border-card {
  box-shadow: none !important;
}

</style>